import React, { useEffect } from "react";
import { ConfigurationPageStyle } from "./Configuration.style";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle, MainStyles } from "../../styles/MainBodyStyles";
import Footer from "../../components/footer/Footer";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { Card1Style } from "../../components/TotalNoCard/TotalNoCard.styled";
import { useNavigate } from "react-router-dom";
import ROUTE from "../../common/Routes";
import { Card2Style } from "../../styles/CardStyles";

const Configurations = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <ConfigurationPageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Configurations</HeadingStyle>
        <MainStyles>
          {/* <Card1Style>
              <div className='card-container' onClick={()=>{navigate(ROUTE.RssiConfig)}}>
                <h2 className='config-heading'>RSSI Configurations</h2>
                  
                <i className="bi bi-arrow-right-circle arrow-style"></i>
                  
              </div>
            </Card1Style> */}
          <Card2Style>
            <div
              className="card-container"
              onClick={() => {
                navigate(ROUTE.EmailConfig);
              }}
            >
              <h2 className="config-heading">Email Configurations</h2>

              <i className="bi bi-arrow-right-circle arrow-style"></i>
            </div>
          </Card2Style>
          <Card2Style>
            <div
              className="card-container"
              onClick={() => {
                navigate(ROUTE.TermOfCondition);
              }}
            >
              <h2 className="config-heading">Terms Of Services</h2>

              <i className="bi bi-arrow-right-circle arrow-style"></i>
            </div>
          </Card2Style>
        </MainStyles>
      </MainBodyStyle>
      <Footer style="footer" />
    </ConfigurationPageStyle>
  );
};

export default Configurations;
